// extracted by mini-css-extract-plugin
export var container = "rating-module--container--a3a33";
export var count = "rating-module--count--98cb1";
export var header = "rating-module--header--ea6cb";
export var infoBox = "rating-module--info-box--feac5";
export var loading = "rating-module--loading--591ac";
export var starBox = "rating-module--star-box--dbcf2";
export var stars = "rating-module--stars--a146c";
export var subtitle = "rating-module--subtitle--9c892";
export var title = "rating-module--title--61045";
export var tooltip = "rating-module--tooltip--7ebd2";